import React from 'react';
import Grid from '../../muiComponents/Grid';
import GridChild from '../../muiComponents/GridChild';
import ContactCard from './ContactCard';
import Card from '../../muiComponents/Card';
import Button from '../../muiComponents/Button';
import useUserProfile from '../../customHooks/useUserProfile';
import { commonIcons } from '../../utils/commonVariables/commonIcons';
import { ProfileViewMode } from '../../types/profile/profileTypes';
import useTranslate from '../../customHooks/useTranslate';
import { useAccountInformation } from '../../contexts/AccountInformationContext';
import {
    gridSpacing30,
    thirdXL_DoubleLG_ColumnGrid,
} from '../../utils/commonVariables/grid';

const ReadOnlyView = () => {
    const { accountInfo, handleDetailContact, handleViewModeChange } =
        useAccountInformation();
    const { readOnlyUser } = useUserProfile();
    const translate = useTranslate();
    const visibleContacts = accountInfo.Contacts.filter(
        contact => !contact.Deleted
    );

    const handleAddContact = () => {
        handleDetailContact();
        handleViewModeChange(ProfileViewMode.EDIT);
    };

    return !visibleContacts.length ? (
        <Card className='contact-card__add flex-column gap-20 padding30'>
            <p role='status'>{translate('no_contacts')}</p>
            {!readOnlyUser && (
                <Button
                    variant='outlined'
                    startIcon={commonIcons.ADD}
                    onClick={handleAddContact}
                >
                    {translate('add_contact')}
                </Button>
            )}
        </Card>
    ) : (
        <Grid
            style={{ width: 'auto', margin: 0 }}
            columnSpacing={gridSpacing30}
            rowSpacing={gridSpacing30}
        >
            {visibleContacts.map(contact => (
                <GridChild
                    key={contact.Id}
                    gridProps={thirdXL_DoubleLG_ColumnGrid}
                >
                    <ContactCard contact={contact} />
                </GridChild>
            ))}
        </Grid>
    );
};

export default ReadOnlyView;
